import type { TranslationPaths } from '../../../types';

export interface TermsStrategy {
  requiresActiveTermsConsent(): boolean;
  checkWhetherPayNowAllowed(args: { paymentButtonHasAcceptedTerms: boolean }): CheckWhetherPayNowAllowedResult;
}

type PayNowDisallowed = {
  status: PayNowPermission.Disallowed;
  errorMessageI18nKey: TranslationPaths;
};

type PayNowAllowed = {
  status: PayNowPermission.Allowed;
};

type CheckWhetherPayNowAllowedResult = PayNowDisallowed | PayNowAllowed;

export enum PayNowPermission {
  Allowed = 'allowed',
  Disallowed = 'disallowed',
}

export function createActiveConsentTermsStrategy(): TermsStrategy {
  return {
    requiresActiveTermsConsent: () => true,
    checkWhetherPayNowAllowed: ({ paymentButtonHasAcceptedTerms }) => {
      if (!paymentButtonHasAcceptedTerms) {
        return {
          status: PayNowPermission.Disallowed,
          errorMessageI18nKey: 'application-layer.payment-button.checkbox-error',
        };
      }

      return { status: PayNowPermission.Allowed };
    },
  };
}

export function createDefaultTermsStrategy(): TermsStrategy {
  return {
    requiresActiveTermsConsent: () => false,
    checkWhetherPayNowAllowed: () => ({
      status: PayNowPermission.Allowed,
    }),
  };
}
